import { useState, useLayoutEffect } from 'react';

export const useWindowSize = () => {
  const [size, setSize] = useState([0, 0]);

  useLayoutEffect(() => {
    let isMounted = true; // flag to track the mounted state and avoid timeouts

    const updateSize = () => {
      if (!isMounted) return;
      setSize([window.innerWidth, window.innerHeight]);
    };

    window.addEventListener('resize', updateSize);
    updateSize();

    return () => {
      window.removeEventListener('resize', updateSize);
      isMounted = false; // Update the mounted state when the component is unmounted
    };
  }, []);

  return size;
}